<template>
  <pack>
    <el-table :data="list" ref="table" class="table" :load="loading">
      <el-table-column label="开发人员" prop="developer" />
      <el-table-column label="版本号" prop="user_version" />
      <el-table-column label="版本描述" prop="user_desc" />
      <el-table-column label="审核结果">
        <template slot-scope="{row}">
          <div :class="formapStatusClass(row.status)">
            {{formapCheckVersion(row.status)}}
            <br v-if="row.status===1" />
            <span v-if="row.status===1" v-html="`原因:${row.reason}`"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="时间" prop="create_time">
        <template slot-scope="{row}">{{formatDate(row.create_time*1000,'YYYY-MM-DD')}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <zt-button
            v-if="(row.status==0)&&(row.is_public==0)"
            size="mini"
            @click="releaseProgram(row)"
          >发布</zt-button>
        </template>
      </el-table-column>
    </el-table>
  </pack>
</template>

<script>
/* eslint-disable */
import {
  admin_plugin_wxapp_api,
  admin_plugin_wxapp_check_list,
} from "@/api/program";
import { formatDate } from "@/utils/date";
export default {
  name: "auditNotice",
  data: () => ({
    loading: false,
    list: [],
  }),
  props: {
    editList: Array,
    active: [String, Number],
  },
  watch: {
    active: {
      immediate: true,
      handler: function (val) {
        if (val == 2) {
          this.getCheckList();
        }
      },
    },
  },
  methods: {
    formatDate,
    formapStatusClass(check_status) {
      switch (check_status) {
        case 0:
          return "success";
          break;
        case 1:
          return "danger";
          break;
        case 2:
          return "warn";
          break;
        case 3:
          return "warn";
          break;
        case 4:
          return "danger";
          break;
        default:
          return "";
      }
    },
    formapCheckVersion(check_status) {
      switch (check_status) {
        case 0:
          return "审核通过";
          break;
        case 1:
          return "审核被拒绝";
          break;
        case 2:
          return "审核中";
          break;
        case 3:
          return "已撤回";
          break;
        case 4:
          return "审核延后";
          break;
        default:
          return "";
      }
    },
    getCheckList() {
      admin_plugin_wxapp_check_list({ wxapp_id: this.editList[0].id }).then(
        ({ data }) => {
          if (data.error_code == 0) {
            this.list = data.list;
          } else {
            this.$message.error(data.error_message);
          }
        }
      );
    },
    releaseProgram() {
      let params = {
        id: this.editList[0].id,
        url: "https://api.weixin.qq.com/wxa/release?access_token=ACCESS_TOKEN",
      };
      this.$confirm("确定发布小程序?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          admin_plugin_wxapp_api(params).then(({ data }) => {
            if (data.error_code == 0 && data.result.errcode == 0) {
              this.$message.succes("小程序发布成功");
            } else if (data.error_code) {
              this.$message.error(data.error_massage);
            } else {
              this.$message.error(data.result.errmsg);
            }
            // 刷新数据
            this.getCheckList();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
/deep/ .cell {
  text-align: center;
}
.danger {
  color: #ff6a6a;
}
.success {
  color: #38af36;
}
.warn {
  color: #ec8f27;
}
</style>